import React from 'react';

function ButtonTabsContent({
  active,
  children,
}) {
  return (
    <div className={'tab-content'}>
      <div className={'tab-pane active'}>
        {children[active] || null}
      </div>
    </div>
  );
}

export default ButtonTabsContent;